import React from 'react';

function TaxBox({ title, value, icon, color, iconSize = 32 }) {
  const c = {
    rose: "text-rose-400 bg-slate-900 border-rose-500/20 shadow-[0_0_20px_rgba(244,63,94,0.1)]",
    amber: "text-amber-400 bg-slate-900 border-amber-500/20 shadow-[0_0_20px_rgba(245,158,11,0.1)]",
    emerald: "text-emerald-400 bg-slate-900 border-emerald-500/20 shadow-[0_0_20px_rgba(16,185,129,0.1)]",
    blue: "text-blue-400 bg-slate-900 border-blue-500/20 shadow-[0_0_20px_rgba(59,130,246,0.1)]"
  };
  return (
    <div className={`p-8 rounded-[45px] border flex items-center gap-6 ${c[color]}`}>
      <div className="p-5 bg-slate-950 rounded-[25px] border border-white/5 shadow-inner">{React.cloneElement(icon, {size: iconSize})}</div>
      <div>
        <p className="text-[11px] font-black uppercase tracking-widest mb-1 opacity-60">{title}</p>
        <div className="text-3xl font-black text-white">{value} <span className="text-xs font-normal opacity-50">s</span></div>
      </div>
    </div>
  );
}

export default TaxBox;
